export class AppConfig {
   
    url: string = 'https://apidev.tjagro.gob.mx/api/';
    //url:string ='http://tjagro.test/api/';

}